import LockIcon from '@mui/icons-material/Lock'
import { Box, Button, Typography } from '@mui/material'
import { FC } from 'react'
import { useTranslate, useLogout } from 'react-admin'

// Shown when an admin-realm user has no sa.* scopes — a loud message beats a silent blank menu.
const NoPermissions: FC = () => {
  const translate = useTranslate()
  const logout = useLogout()

  return (
    <Box sx={{ p: 4, textAlign: 'center', mt: 8 }}>
      <LockIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
        {translate('page.noPermissions.title')}
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        {translate('page.noPermissions.text')}
      </Typography>
      <Button variant="contained" onClick={() => { void logout() }}>
        {translate('ra.auth.logout')}
      </Button>
    </Box>
  )
}

export default NoPermissions
